import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const useResetGlobalLetter = (): VoidFunction => {
  const queryClient = useQueryClient();

  const handleResetGlobalLetter = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: ['globalLetter'],
      exact: false,
    });
  }, [queryClient]);

  return handleResetGlobalLetter;
};
